if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();

        this.modalQuerySelectorString = `[id^="QuickAddInfo-"]`;

				this.modalContent = this.querySelector(this.modalQuerySelectorString);

				window.addEventListener("keyup", (event) => {
					if (event.code.toUpperCase() === "ESCAPE") this.hide();
				});

				window.addEventListener("resize", function () {
					$(".js-media-list").each(function () {
						this.swiper?.destroy();
					});
					$(".js-media-sublist").each(function () {
						this.swiper?.destroy();
					});

					setTimeout(() => {
						subSliderInit(true, 16);
						sliderInit(true);
					}, 200);
				});

        this.klaviyoBisEnabled = window.klaviyoBisEnabled ? Boolean(window.klaviyoBisEnabled === true) : false;
        this.klaviyoCompanyId = window.klaviyoCompanyId ? String(window.klaviyoCompanyId) : false;
				this.scrollLockActive = false;
				this.scrollLockY = 0;

			}

			lockBackgroundScroll() {
				if (this.scrollLockActive) return;

				this.scrollLockY = window.scrollY || window.pageYOffset || 0;
				document.body.style.position = "fixed";
				document.body.style.top = `-${this.scrollLockY}px`;
				document.body.style.left = "0";
				document.body.style.right = "0";
				document.body.style.width = "100%";
				this.scrollLockActive = true;
			}

			unlockBackgroundScroll() {
				if (!this.scrollLockActive) return;

				const scrollY = this.scrollLockY;

				document.body.style.position = "";
				document.body.style.top = "";
				document.body.style.left = "";
				document.body.style.right = "";
				document.body.style.width = "";
				this.scrollLockActive = false;
				this.scrollLockY = 0;
				window.scrollTo(0, scrollY);
			}

      klaviyoBisActivate() {
        if (!this.klaviyoBisEnabled && !this.klaviyoCompanyId) return;

        if (window.klaviyo && window.klaviyo._bis) {
          delete window.klaviyo._bis;
        }

        setTimeout(() => {
          // Klaviyo's MainView bails out early (never populating unavailable_variants) on pages
          // that aren't /products/ or /collections/, causing "Cannot read properties of undefined
          // (reading '0')" on click. Fix: force the quickview/collection-page flow by passing
          // collection_urls + is_quick_view, and stamping the two data attributes Klaviyo needs
          // on the trigger so it can fetch the product JSON and resolve the correct variant.
          const bisTriggers = this.modalContent.querySelectorAll('.klaviyo-bis-trigger');

          if (bisTriggers.length) {
            bisTriggers.forEach(el => {
              if (this.bisProductHandle) {
                el.setAttribute('data-klaviyo-handle', this.bisProductHandle);
              }
              // Klaviyo reads this as a jQuery selector and calls .val() on the result to get
              // the currently-selected variant ID from the quick-add modal form.
              el.setAttribute('data-klaviyo-quickview-variant', 'quick-add-modal input[name="id"]');
            });
          }

          window.klaviyoBisActivate('klaviyo-bis-trigger', {
            // Empty-string pattern matches any URL, making Klaviyo treat every host page
            // as a collection page and take the quickview path instead of returning early.
            collection_urls: [''],
            is_quick_view: true,
          });
        }, 1000);

      }

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
				this.modalContent.innerHTML = "";

				$(".js-media-list").each(function () {
					this.swiper.destroy();
				});
				$(".js-media-sublist").each(function () {
					this.swiper.destroy();
				});

				subSliderInit(true, 16);
				sliderInit(true);

				if (preventFocus) this.openedBy = null;
				super.hide();
				if (!document.querySelector("body > quick-add-modal[open]")) {
					this.unlockBackgroundScroll();
				}
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");
				this.lockBackgroundScroll();

				const productUrl = opener.getAttribute("data-product-url") || '';
				const handleMatch = productUrl.match(/\/products\/([^/?#]+)/);
				this.bisProductHandle = handleMatch ? handleMatch[1] : null;

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				fetch(opener.getAttribute("data-product-url"))
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(
							this.modalContent,
							this.productElement.innerHTML,
							opener
						);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.updateImageSizes();
						this.preventVariantURLSwitching();
						super.show(opener);

					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						$(".js-media-list").each(function () {
							this.swiper?.destroy();
						});
						$(".js-media-sublist").each(function () {
							this.swiper?.destroy();
						});
						ratingSnippet("ruk_rating_snippet", {
							store: "www.babies.co.nz",
							mode: "default",
							color: "#F5374E",
							linebreak: false,
							text: "",
							singularText: "",
							lang: "en",
							usePolaris: false,
							showEmptyStars: false,
							showNumericalAverageRating: false,
						});
						subSliderInit(true, 16,3);
						sliderInit(true);

            this.klaviyoBisActivate();

					});
			}

			setInnerHTML(element, html, opener) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});

				// Read more button
				const moreBtn = document.createElement("a");
				moreBtn.innerHTML = `<span class="small-font">${theme.quickviewMore}</span>`;
				moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
				moreBtn.setAttribute(
					"class",
					"product__full-details button button--simple"
				);
				if (
					element.querySelectorAll(".product__info-column") &&
					element.querySelectorAll(".product__info-column").length > 0
				) {
					element.querySelector(".product__info-container").appendChild(moreBtn);
				} else {
					element.querySelector(".product__info-container").appendChild(moreBtn);
				}

			}

			removeDOMElements() {
				const popup = this.productElement.querySelectorAll(".product-popup");
				if (popup)
					popup.forEach((el) => {
						el.remove();
					});

				const about = this.productElement.querySelectorAll(".about");
				if (about)
					about.forEach((el) => {
						el.remove();
					});

				const shareButtons =
					this.productElement.querySelector(".share-buttons");
				if (shareButtons) shareButtons.remove();

				const sku = this.productElement.querySelector(".product__sku");
				if (sku) sku.remove();

				const breadcrumb = this.productElement.querySelector(".breadcrumb");
				if (breadcrumb) breadcrumb.remove();

				const multicolumnInformation = this.productElement.querySelector(".information_multicolumn");
				if (multicolumnInformation) multicolumnInformation.remove();

				const tags = this.productElement.querySelector(".product-tags");
				if (tags) tags.remove();

				const pickupAvailability = this.productElement.querySelector(
					".pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				// const productInventory = this.productElement.querySelector(
				// 	".product__shipping-oversize"
				// );
				// if (productInventory) productInventory.remove();

				const iconWithTexts = this.productElement.querySelectorAll(
					".product__text-icons"
				);
				if (iconWithTexts)
					iconWithTexts.forEach((el) => {
						el.remove();
					});

				const description = this.productElement.querySelectorAll(
					".product__description"
				);
				if (description)
					description.forEach((el) => {
						el.remove();
					});

				const descriptionImage = this.productElement.querySelector(
					".product__description-image-box"
				);
				if (descriptionImage) descriptionImage.remove();

				const characteristics = this.productElement.querySelector(
					".product-characteristics"
				);
				if (characteristics) characteristics.remove();

				const recommendations = this.productElement.querySelector(
					".product-recommendations--single"
				);
				if (recommendations) recommendations.remove();

				// const customBadges = this.productElement.querySelector(
				// 	".product__custom-badges"
				// );
				// if (customBadges) customBadges.remove();

				// const productModal = this.productElement.querySelector(
				// 	"product-modal"
				// );
				// if (productModal) productModal.remove();
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}
		}
	);
}
